import { ReactNode } from 'react';
import { Box } from '@mui/material';

export function SectionCard({
    title,
    children,
    disableContentPadding,
}: {
    title: ReactNode;
    children: ReactNode;
    disableContentPadding?: boolean;
}) {
    return (
        <Box
            sx={{
                backgroundColor: 'common.white',
                border: 1,
                borderColor: 'blue.light',
            }}
        >
            <Box
                sx={{
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    paddingX: '28px',
                    backgroundColor: 'blue.light',
                    color: 'blue.main',
                    fontSize: '16px',
                    fontWeight: 700,
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                }}
            >
                {title}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '22px',
                    paddingY: disableContentPadding ? 0 : '24px',
                    paddingX: disableContentPadding ? 0 : '28px',
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
